import { CheckCircle2, Car, Calendar, CreditCard } from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

export function SubscribersPreview() {
  const { t } = useI18n()

  return (
    <section className="py-20 bg-muted/30" id="mensalistas">
      <div className="container mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1 animate-fade-in">
          <div className="bg-card rounded-xl shadow-xl border overflow-hidden max-w-md mx-auto relative">
            <div className="absolute top-0 right-0 bg-emerald-500 text-white px-3 py-1.5 rounded-bl-lg text-xs font-bold uppercase tracking-wider shadow-sm flex items-center gap-1">
              <CheckCircle2 className="h-4 w-4" /> {t('sub.active')}
            </div>
            <div className="p-6 border-b pt-8">
              <h3 className="font-extrabold tracking-tight text-2xl">
                João da Silva
              </h3>
              <p className="text-muted-foreground font-medium text-sm mt-1">
                joao@empresa.com • (11) 99999-9999
              </p>
            </div>
            <div className="p-6 bg-muted/20 space-y-4">
              <div className="flex justify-between items-center bg-background p-3 rounded-lg border shadow-sm">
                <div className="flex items-center gap-3 font-semibold">
                  <Car className="text-primary h-5 w-5" /> {t('sub.plates')}
                </div>
                <div className="font-mono text-sm font-bold flex flex-col items-end gap-1">
                  <span className="bg-secondary/10 text-secondary border border-secondary/20 px-2 py-0.5 rounded tracking-tight">
                    ABC-1234
                  </span>
                  <span className="bg-secondary/10 text-secondary border border-secondary/20 px-2 py-0.5 rounded tracking-tight">
                    XYZ-9876
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center bg-background p-3 rounded-lg border shadow-sm">
                <div className="flex items-center gap-3 font-semibold">
                  <Calendar className="text-primary h-5 w-5" />{' '}
                  {t('sub.dueDate')}
                </div>
                <div className="font-bold text-foreground">
                  {t('sub.dueDay')}
                </div>
              </div>
              <div className="flex justify-between items-center bg-background p-3 rounded-lg border shadow-sm">
                <div className="flex items-center gap-3 font-semibold">
                  <CreditCard className="text-primary h-5 w-5" />{' '}
                  {t('sub.monthlyFee')}
                </div>
                <div className="font-extrabold tracking-tight text-lg text-emerald-600">
                  R$ 250,00
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="order-1 md:order-2 space-y-6 animate-fade-in-up">
          <div className="inline-block px-3 py-1 bg-emerald-500/10 text-emerald-600 rounded-full text-sm font-bold tracking-wider uppercase mb-2">
            {t('sub.badge')}
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter leading-tight">
            {t('sub.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-medium">
            {t('sub.subtitle')}
          </p>
          <ul className="space-y-6 pt-4">
            <li className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-lg">
                <CheckCircle2 className="h-6 w-6 text-primary shrink-0" />
              </div>
              <div>
                <strong className="block text-foreground font-bold text-lg mb-1 tracking-tight">
                  {t('sub.recognitionTitle')}
                </strong>
                <span className="text-muted-foreground font-medium text-base">
                  {t('sub.recognitionDesc')}
                </span>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-lg">
                <Car className="h-6 w-6 text-primary shrink-0" />
              </div>
              <div>
                <strong className="block text-foreground font-bold text-lg mb-1 tracking-tight">
                  {t('sub.multiplePlatesTitle')}
                </strong>
                <span className="text-muted-foreground font-medium text-base">
                  {t('sub.multiplePlatesDesc')}
                </span>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-lg">
                <Calendar className="h-6 w-6 text-primary shrink-0" />
              </div>
              <div>
                <strong className="block text-foreground font-bold text-lg mb-1 tracking-tight">
                  {t('sub.defaultControlTitle')}
                </strong>
                <span className="text-muted-foreground font-medium text-base">
                  {t('sub.defaultControlDesc')}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}
